module.exports = __webpack_public_path__ + "img/banner5.febad22e.jpg";